import { render, staticRenderFns } from "./ECNHalfYear2025.vue?vue&type=template&id=028ee7f6&scoped=true"
import script from "./ECNHalfYear2025.vue?vue&type=script&lang=js"
export * from "./ECNHalfYear2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ee7f6",
  null
  
)

export default component.exports